import apiUrl from "../../../constants";
import axios from "axios";
import Paginate from "vuejs-paginate";
import CryptoJS from "crypto-js";
import VueElementLoading from "vue-element-loading";
import moment from "moment";
import DatePicker from "vue2-datepicker";
import user_tracker from "../../../usertracker";
import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css'
import download from 'downloadjs';
import utils from "../../../utils/validateScanner"


export default {
  name: "inscan-overage-shipment",
  mixins: [utils],
  components: {
    VueElementLoading,
    Paginate,
    DatePicker,
    Multiselect,
    download
  },
  props: [],
  data() {
    return {
      isLoading: false,
      OverageShipmentList: [],
      hublist: [],
      hub: "",
      checkedType: "",
      shippingID: "",
      shippingIDError: "",
      checkedTypeError: "",
      hubid: "",
      hubName: "",
      createdbyemail: "",
      pageNo: 0,
      limit: 20,
      pageCount: 0,
      totalRows: 0,
      token: "",
      timeoutHandler: 0,
      inputString: "",
      manualInput: false,
      userData: [],
      FromDate: moment().subtract(14, 'days').format('YYYY-MM-DD HH:mm:ss'),
      todate: moment().format('YYYY-MM-DD HH:mm:ss'),
      todaysDate:new Date(),
      hubZone: '',
      HubZoneListData: [],
      isLoading: false,
      hubLoading: false,
      hubIds: [],
      overagehubids: [],
      updatedOverageShipmentList: [],
      showModal: false, 
      imgData: "" ,
      reason :''  ,
      reasonMap: {},
      imagesViewedMap: {},
      disabledbuttonMapApproved:{},
      disabledbuttonMapRejected: {},
      hubIdError :'',
      reasonlist: [
        { value: 1, label: 'AWB number missing or unclear' },
        { value: 2, label: 'Mismatch between image & actual shipment' },
        { value: 3, label: 'Image matched but shipment not Intact' },
        { value: 4, label: 'Image matched & Shipment Intact' }
      ],
    };
  },
  computed: {},
  filters: {
    moment: function (date) {
      if (date == null || date == "") return "--";
      return moment(date).format("DD-MM-YYYY HH:mm:ss");
    },
  },
  mounted() {
    var userTokenEncrypt = window.localStorage.getItem("userToken");
    var userTokenDecrypt = CryptoJS.AES.decrypt(
      userTokenEncrypt.toString(),
      "Key"
    );
    var userToken = userTokenDecrypt.toString(CryptoJS.enc.Utf8);
    this.token = JSON.parse(userToken);
    var userdetailEncrypt = window.localStorage.getItem("userdetail");
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), "Key");
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext);
    this.userData = userdetail;
    this.hubid = userdetail[0].HubId[0];
    this.createdbyemail = userdetail[0].email;
    this.getHubList();
  },
  methods: {

    checkBarcode(e) {
      if (this.timeoutHandler) {
        clearTimeout(this.timeoutHandler);
        this.inputString += String.fromCharCode(e.keyCode);
      }
      this.timeoutHandler = setTimeout(() => {
        if (this.inputString.length <= 3) {
          this.manualInput = true;
          this.inputString = "";
        } else {
          this.manualInput = false;
          this.inputString = "";
        }
      }, 10);
    },
    getHubList() {
      this.hubLoading = true;
      this.input={
        'userid': this.userData[0].userid,
        'currenthubid': this.hubid
      }
      axios({
        method: "POST",
        url: apiUrl.api_url_hubops + "getAllocatedHubsForUser",
        data: this.input,
        headers: {
          authorization: "authkey xB84JJ89Hd25",
        },
      }).then(
        (result) => {
          this.hubLoading = false;
          var HubDetails = result.data.ResponseData;
          for (var i = 0; i < HubDetails.length; i++) {
            this.hublist.push({
              value: HubDetails[i].HubID,
              text: HubDetails[i].HubName + "(" + HubDetails[i].HubID + ")",
            });
          }
        },
        (error) => {
          this.hubLoading = false;
          console.error(error);
        }
      );
    },
    showOverageDetails(ShippingID) {
      
      this.OverageShipmentList=[];
      this.updatedOverageShipmentList=[];
      let selectedhubids;
      
        this.totalRows = 0;
        this.input = {
          pageIndex: this.pageNo,
          pageSize: this.limit,
          currentHubId : this.hubid,
          type : 'Overage'
        };
      
      if(this.hubIds.length > 0){
        let hubIdsArray = Array.from(this.hubIds);
        selectedhubids = hubIdsArray.map(item => item.value);
        this.input["hubIds"] = selectedhubids;
      }else{
        this.hubIdError = "Please select hub"
        return false;
      }
      this.isLoading = true;
        if (ShippingID) {
          this.input["shippingId"] =ShippingID;
        }
          this.input["FromDate"] = this.FromDate;
          this.input["ToDate"] = this.todate;
          
          axios({
            method: "POST",
            url: apiUrl.api_url_hubops + "approvalPendingList",
            data: this.input,
            headers: {
              authorization: "authkey xB84JJ89Hd25",
              token: this.token,
            },
          })
            .then((response) => {
              this.isLoading = false;
              this.hubIdError = "";
              if (response.data.ResultCode == 100) {
                this.OverageShipmentList = response.data.ResponseData;
                
                this.overagehubids = [...new Set(this.OverageShipmentList.map(a => a.overagehubid))];
                if(this.overagehubids.length > 0){
                  this.gethubZoneByHubId(this.overagehubids);
                  }
                this.totalRows = response.data.TotalCount;
                
                if (this.totalRows < this.limit) {
                  this.pageCount = 1;
                } else {
                  this.pageCount = Math.ceil(this.totalRows / this.limit);
                }
                if(Object.keys(response.data.lossCategorization).length !=0){
                  this.colorCode = response.data.lossCategorization.colorCode;
              		this.colorIcon = response.data.lossCategorization.icon;
    							}
              }  else {
                this.OverageShipmentList = [];
                this.showHideCodeIconInput();
                this.$alertify.error(response.data.ReturnMessage);
              }
            })
            .catch((httpException) => {
              this.isLoading = false;
              this.showHideCodeIconInput();
              console.error("exception is:::::::::", httpException);
            });
    },
    getPaginationData(pageNum) {
      this.pageNo = pageNum - 1;
      this.showOverageDetails();
    },

    gethubZoneByHubId(hubids) {
      this.isLoading = true;
      this.input = ({
        'facilityIds': hubids,
      });
      axios({
        method: 'post',
        url: apiUrl.api_url_hubops + 'getHubdetailsFromFMS',
        data: this.input,
        headers: {
          'Content-Type': 'application/json',
          'authorization': 'authkey xB84JJ89Hd25',
        },
      })
      .then((result) => {
        this.isLoading = false;
        if (result.data.ResultCode == 100) {
        let facilitiesDetails = result.data.ResponseData.facilitiesDetails;
        this.updatedOverageShipmentList = this.OverageShipmentList.map(shipment => {
          const facility = facilitiesDetails.find(facility => facility.facilityId === shipment.overagehubid);
          if (facility) {
              shipment.zoneId = facility.zoneId;
              shipment.hubname = facility.facilityName;
          }
          const shippingid = shipment.shippingid;

  // Initialize row-level state maps
      this.$set(this.reasonMap, shippingid, null); 
      this.$set(this.imagesViewedMap, shippingid, [false, false]); 
      this.$set(this.disabledbuttonMapApproved, shippingid, true); 
      this.$set(this.disabledbuttonMapRejected, shippingid, true); 
        
          return shipment;
      });
      
      }else{
        this.$alertify.error(result.data.ReturnMessage);
      }
      })
      .catch((error) => console.error(error));
    },

    downloadImage(data, ind) {
      if (!data.imageurl) {
      this.$alertify.error("No image URL found.");
      return;
      }
      
      const urls = data.imageurl.split(',').map(url => url.trim());
      const selectedUrl = urls[ind];
      
      if (!selectedUrl) {
      this.$alertify.error("Image ${ind} not available.");
      return;
      }
      const path = selectedUrl.split(".com")[1];
      
      this.imgData = `${apiUrl.cloudfronturl}${path}`;
      this.showModal = true;
      
      const shippingid = data.shippingid;
      const viewed = this.imagesViewedMap[shippingid] || [false, false];
      viewed[ind] = true;
      this.$set(this.imagesViewedMap, shippingid, viewed);
      
      this.allImagesViewed(shippingid);
      },

    selectedReason(selected, shippingid) {
      this.$set(this.reasonMap, shippingid, selected);
      this.allImagesViewed(shippingid);
    },
    allImagesViewed(shippingid) {
      const reasonSelected = !!this.reasonMap[shippingid];
      const images = this.imagesViewedMap[shippingid] || [false, false];
    
      if (reasonSelected) {
        const reasonValue = this.reasonMap[shippingid].value;
        const bothImagesViewed = images[0] && images[1];
    
        if (bothImagesViewed) {
          if (reasonValue == 4) {
            this.$set(this.disabledbuttonMapApproved, shippingid, false);
            this.$set(this.disabledbuttonMapRejected, shippingid, true);
          } else {
            this.$set(this.disabledbuttonMapApproved, shippingid, true);
            this.$set(this.disabledbuttonMapRejected, shippingid, false);
          }
        } else {
          this.$set(this.disabledbuttonMapApproved, shippingid, true);
          this.$set(this.disabledbuttonMapRejected, shippingid, true);
        }
      }
    },
    closeImage() {
      this.showModal = false; 
    },
    actionOnShipment(data,action) {
    this.isLoading = true;
      this.input = {
        hubId : data.overagehubid,
        type : 'Overage',
        shippingId :data.shippingid,
        lastModifiedBy : this.createdbyemail,
        comment : this.reasonMap[data.shippingid].label,
        action : action,
        isManualEntry:this.manualInput
      };
    
        axios({
          method: "POST",
          url: apiUrl.api_url_hubops + "overageShortageToInscan",
          data: this.input,
          headers: {
            authorization: "authkey xB84JJ89Hd25",
            token: this.token,
          },
        })
          .then((response) => {
            this.isLoading = false;
            if (response.data.ResultCode == 100) {
              
              this.$alertify.success(response.data.ReturnMessage);
              this.reasonMap={};
              this.imagesViewedMap={};
              this.disabledbuttonMapApproved={};
              this.disabledbuttonMapRejected={};
              this.pageNo=0;
              this.showOverageDetails();
            }  else {
              this.$alertify.error(response.data.ReturnMessage);
            }
          })
          .catch((httpException) => {
            this.isLoading = false;
            console.error("exception is:::::::::", httpException);
          });
  },
    resetForm() {
      this.checkedType = "";
      this.checkedTypeError = "";
      this.OverageShipmentList = [];
      this.isLoading = false;
      this.$validator.reset();
      this.FromDate = "";
      this.todate = "";
      this.hubZone= '';
      this.hubLoading= false;
      this.hubIds= [];
      this.overagehubids= [];
      this.updatedOverageShipmentList= [];
      this.totalRows = 0;
      this.reason =''  ;
      this.reasonMap={};
      this.imagesViewedMap={};
      this.disabledbuttonMapApproved={};
      this.disabledbuttonMapRejected={};
      this.limit=20;
      this.hubIdError ='';
      this.disabledbutton = true;
      this.showHideCodeIconInput();
    },
    clearID() {
      this.shippingID = "";
      this.shippingIDError = "";
      this.opened = [];
      this.OverageShipmentList = [];
      this.FromDate = "";
      this.todate = "";
      this.isLoading = false;
      this.hubZone= '';
      this.hubLoading= false;
      this.hubIds= [];
      this.overagehubids= [];
      this.updatedOverageShipmentList= [];
      this.reason =''  ;
      this.totalRows = 0;
      this.limit=20;
      this.hubIdError ='';
      this.disabledbutton = true;
      this.reasonMap={};
      this.imagesViewedMap={};
      this.disabledbuttonMapApproved={};
      this.disabledbuttonMapRejected={};
      this.showHideCodeIconInput();
    },

    clearError() {
      if (this.shippingID == "") {
        this.shippingIDError = "The shipping ID field is required.";
      } else {
        this.shippingIDError = "";
      }
    },


     jsonToCSV(filename, data, csvfield, dateFilder = [], skipFilter = []) {
             var csvData = ''
             //Header
             if (this.title != null) {
               csvData += this.parseExtraData(this.title, '${data}\r\n')
             }
             //Fields
             for (let key in data[0]) {
               if (skipFilter.indexOf(key) == -1)
                 csvData += csvfield[key] + ','
             }
             csvData = csvData.slice(0, csvData.length - 1)
             csvData += '\r\n'
             //Data
             data.map(function(item) {
               for (let key in item) {
                 if (skipFilter.indexOf(key) == -1) {
                   var escapedCSV = item[key] + '' // cast Numbers to string
                   if (escapedCSV.match(/[,"\n]/)) {
                     escapedCSV = '"' + escapedCSV.replace(/\"/g, "\"\"") + '"'
                   }
                   if (escapedCSV == 'null')
                     csvData += ',';
                   else {
                     if (dateFilder.indexOf(key) != -1)
                       csvData += moment(escapedCSV).format('DD-MM-YYYY HH:mm:ss') + ','
                     else
                       csvData += escapedCSV + ','
                   }
                 }
               }
               csvData = csvData.slice(0, csvData.length - 1)
               csvData += '\r\n'
             })
             //Footer
             if (this.footer != null) {
               csvData += this.parseExtraData(this.footer, '${data}\r\n')
             }
             filename += moment().format('DD-MM-YYYY') + '.csv';
             return this.export(csvData, filename, "application/csv");
             return csvData
           },
        
            export (data, filename, mime) {
             let blob = this.base64ToBlob(data, mime)
             download(blob, filename, mime)
           },
        
            base64ToBlob(data, mime) {
             let base64 = window.btoa(window.unescape(encodeURIComponent(data)))
             let bstr = atob(base64)
             let n = bstr.length
             let u8arr = new Uint8ClampedArray(n)
             while (n--) {
               u8arr[n] = bstr.charCodeAt(n)
             }
             return new Blob([u8arr], {
               type: mime
             })
           },

           exportList(){
            this.csvData=[]
            this.updatedOverageShipmentList.map(item=>{
              this.csvData.push({
                ShippingID: item.shippingid,
                UserEmail:item.approvalrequestedby,
                OverageHubName: item.hubname,
                ShipmentType: item.shipmenttype,
                CreatedAt : item.approvalrequesteddate,
                OverageCount :item.overagecount,
                ApprovalRequestedHubName: item.hubname,
                ImageURL: item.imageurl,
              })
            })
            this.csvFields = {
              'ShippingID': 'ShippingID',
              'UserEmail': 'UserEmail',
              'OverageHubName': 'OverageHubName',
              'ApprovalRequestedHubName':'ApprovalRequestedHubName',
              'ShipmentType': 'ShipmentType',
              'OverageCount': 'OverageCount',
              'CreatedAt': 'CreatedAt',
              'ImageURL': 'ImageURL',
            }
            this.jsonToCSV('OverageApprovalStatusData', this.csvData, this.csvFields);
          },
  },
};



// WEBPACK FOOTER //
// ./src/views/components/OverageApprovalPanel/OverageApprovalPanel.js